/** @format */

import { CommonModule } from '@angular/common';
import { HmfDrawerComponent } from '@dsg-tech/homefield-angular';
import { NgModule } from '@angular/core';
import { ReviewInformationDrawerComponent } from './review-information-drawer.component';
import { ReviewQuestionsAndAnswersModule } from '../review-questions-and-answers/review-questions-and-answers.module';
import { ReviewsDrawerContainerModule } from '../reviews-drawer-container/reviews-drawer-container.module';
import { TrapFocusModule } from '../directive/trap-focus/trap-focus.module';

@NgModule({
	imports: [
		CommonModule,
		HmfDrawerComponent,
		ReviewQuestionsAndAnswersModule,
		ReviewsDrawerContainerModule,
		TrapFocusModule
	],
	declarations: [ReviewInformationDrawerComponent],
	exports: [ReviewInformationDrawerComponent]
})
export class ReviewInformationDrawerModule {
	constructor() {}
}
